const ID_SEPARATOR = ':';



export interface OvsParsedSystemId {
	clientId: string,
	version: number,
	ovsCustomerId: string,
	type: string
}

export interface ParsedUnversionedSystemId {
	clientId: string,
	ovsCustomerId: string,
	type: string
}



export const getParsedSystemId = (systemId: string): OvsParsedSystemId => {
	let defaultSystemId = {
		clientId: 'default',
		version: 0,
		ovsCustomerId: 'default',
		type: 'default',
	}

	if (!systemId || systemId.length === 0) {
		return defaultSystemId;
	}

	const splitted = systemId.split(ID_SEPARATOR);
	if (!splitted || splitted.length !== 4) {
		return defaultSystemId;
	}

	let parsedSystemId: OvsParsedSystemId = {
		clientId: splitted[0] ?? 'default',
		version: splitted[1] ? parseInt(splitted[1]) : 0,
		ovsCustomerId: splitted[2] ?? 'default',
		type: splitted[3] ?? 'default',
	}
	return parsedSystemId;
}



export const getParsedUnversionedSystemId = (systemId: string): ParsedUnversionedSystemId => {
	let defaultSystemId = {
		clientId: 'default',
		ovsCustomerId: 'default',
		type: 'default',
	}

	if (!systemId || systemId.length === 0) {
		return defaultSystemId;
	}

	const splitted = systemId.split(ID_SEPARATOR);
	if (!splitted || splitted.length !== 3) {
		return defaultSystemId;
	}

	let parsedSystemId: ParsedUnversionedSystemId = {
		clientId: splitted[0] ?? 'default',
		ovsCustomerId: splitted[1] ?? 'default',
		type: splitted[2] ?? 'default',
	}
	return parsedSystemId;
}